import React, { useState } from 'react'
import AddFaqCategoryModal from '../../components/shared/modalContent/AddFaqCategoryModal'
import { useGetFaqCategoriesQuery } from '../../app/faqApi/faqApi'
import Button from '../../components/shared/buttons/button'
import { useNavigate } from 'react-router'
const FaqCategories = () => {
    const navigate = useNavigate();
    const { data: categories } = useGetFaqCategoriesQuery();
    const [showModal, setShowModal] = useState(false);
    const [editId, setEditId] = useState(null);
    return (
        <>
            <div className="d-flex justify-content-between mb-3 align-items-center">
                <h6 className='mb-0 cmn_heading'>FAQ Categories</h6>
                <Button label="Add Category" size="xs" onClick={() => { setEditId(null); setShowModal(true); }} />
            </div>

            <ul className='p-0 d-flex flex-column gap-3'>
                {categories?.data?.map((cat) => (
                    <li key={cat._id} className="d-flex justify-content-between survey-assign gap-3 align-items-center">
                        <span className='flex-grow-1'>{cat?.name}</span>
                        <Button
                            label="Edit"
                            size="xs"
                            onClick={() => {
                                setEditId(cat?._id);
                                setShowModal(true);
                            }}
                            className={'borderedBtn'}
                        />
                        <Button
                            label="View"
                            size="xs"
                            onClick={() => {
                                navigate(`/faq-categories/faq/${cat?._id}`);
                                setShowModal(true);
                            }}
                        />
                    </li>
                ))}
            </ul>

            <AddFaqCategoryModal show={showModal} setShow={setShowModal} handleClose={() => setShowModal(false)} editId={editId} />
        </>
    )
}

export default FaqCategories